import { ConversationDto } from "../dto/conversation";
import { TemplateDto } from "../dto/template";

export const roles = {
  roles: [
    {
      id: "20000000-0000-0000-0000-000000000001",
      name: "Operator",
      description:
        "Gestisce le conversazioni assegnate e può rispondere ai clienti.",
      canAssign: false,
      canTransfer: true,
      canViewAll: false,
      canClose: false,
    },
    {
      id: "20000000-0000-0000-0000-000000000002",
      name: "Supervisor",
      description:
        "Supervisiona il team, assegna conversazioni e può chiuderle.",
      canAssign: true,
      canTransfer: true,
      canViewAll: true,
      canClose: true,
    },
    {
      id: "20000000-0000-0000-0000-000000000003",
      name: "Admin",
      description:
        "Amministratore con accesso completo alla piattaforma e alle impostazioni.",
      canAssign: true,
      canTransfer: true,
      canViewAll: true,
      canClose: true,
    },
  ],
};

export const me = {
  id: "eebacbeb-5597-4f0e-82dc-93794a4d5931",
  name: "Eugenio Azzolin",
  email: "e.azzolin@consulcesi.com",
  teamId: "10000000-0000-0000-0000-000000000004",
  teamName: "Customer",
  roleId: "20000000-0000-0000-0000-000000000002",
  roleName: "Supervisor",
  isActive: true,
};

export const conversations = [
  {
    id: "9a819343-ed72-4a17-a7dd-1fae28c5fe8d",
    twilioSid: "CH1fb3e853c6124f57a19eeb9efa8bcc3c",
    channelType: "whatsapp",
    state: 0,
    customers: [],
    customerPhone: "whatsapp:+73391100643",
    lastMessageText: "Gentile Dottore ho provato a contattarla...",
    lastMessageAt: "2025-11-29T17:26:00",
    createdAt: "2025-10-29T14:42:58",
    operatorId: "eebacbeb-5597-4f0e-82dc-93794a4d5931",
    operatorName: "a.nunzi",
    teamId: "10000000-0000-0000-0000-000000000004",
    teamName: "Customer",
    lockedByOperatorId: null,
    lockedByOperatorName: null,
  },
  {
    id: "d2a4d1d4-4d09-4276-8a1f-4e5e36a02b31",
    twilioSid: "CH3c6a74a5cbb645789add2f8a6a9e35af",
    channelType: "whatsapp",
    state: 0,
    customers: [
      { name: "Mario", surname: "Rossi", code: "112233" },
      { name: "Maria", surname: "Rossi", code: "445566" },
    ],
    customerPhone: "whatsapp:+393391100643",
    lastMessageText: "Novità sulla Tua Azione Legale! Vuoi ric...",
    lastMessageAt: "2025-11-29T09:48:00",
    createdAt: "2025-10-12T10:15:22",
    operatorId: "49f2d5f8-b6ff-40da-bed8-64ced002677a",
    operatorName: "a.musu",
    teamId: "10000000-0000-0000-0000-000000000004",
    teamName: "Customer",
    lockedByOperatorId: null,
    lockedByOperatorName: null,
  },
  {
    id: "b7f1a2b2-15b8-4d0f-8fef-3f34f8a3f0b3",
    twilioSid: "CH8be4adf8a6d24c3bb8f12fca3e9a1d02",
    channelType: "whatsapp",
    state: 1,
    customers: [{ name: "medico Test", surname: "OW", code: "859500" }],
    customerPhone: "whatsapp:+390000000000",
    lastMessageText: "Perfetto dottore, qualche istante e sapr...",
    lastMessageAt: "2025-11-29T12:57:00",
    createdAt: "2025-11-01T08:30:10",
    operatorId: "49f2d5f8-b6ff-40da-bed8-64ced002677a",
    operatorName: "a.nunzi",
    teamId: "10000000-0000-0000-0000-000000000004",
    teamName: "Customer",
    lockedByOperatorId: null,
    lockedByOperatorName: null,
  },
] as ConversationDto[];

export const templates: TemplateDto[] = [
  // string + string
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f01",
    name: "Saluto iniziale",
    content:
      "Ciao! Sono {{operatorName}} del team {{teamName}}.\r\nCome posso aiutarti oggi?",
    templateSid: "tpl_saluto_iniziale",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [
      { key: "operatorName", type: "string" },
      { key: "teamName", type: "string" },
    ],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c01",
    categoryName: "Apertura",
    isActive: true,
    createdAt: "2025-12-02T10:05:00.000Z",
  },

  //  number
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f02",
    name: "Richiesta numero ordine",
    content:
      "Per aiutarti al meglio, indicami il numero d’ordine: {{orderNumber}}",
    templateSid: "tpl_richiesta_numero_ordine",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [{ key: "orderNumber", type: "number" }],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c02",
    categoryName: "Verifica",
    isActive: true,
    createdAt: "2025-12-02T10:06:00.000Z",
  },

  //  date
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f03",
    name: "Data appuntamento",
    content: "Perfetto. Confermi la data: {{appointmentDate}} ?",
    templateSid: "tpl_data_appuntamento",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [{ key: "appointmentDate", type: "date" }],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c03",
    categoryName: "Appuntamenti",
    isActive: true,
    createdAt: "2025-12-02T10:07:00.000Z",
  },

  // time
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f04",
    name: "Orario preferito",
    content: "A che ora preferisci essere ricontattato/a? {{preferredTime}}",
    templateSid: "tpl_orario_preferito",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [{ key: "preferredTime", type: "time" }],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c03",
    categoryName: "Appuntamenti",
    isActive: true,
    createdAt: "2025-12-02T10:08:00.000Z",
  },

  //  datetime
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f05",
    name: "Programmazione richiamo",
    content:
      "Ok, ho programmato il richiamo per: {{callbackAt}}.\r\nSe hai altre info, scrivimi pure.",
    templateSid: "tpl_programmazione_richiamo",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [{ key: "callbackAt", type: "datetime" }],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c04",
    categoryName: "Aggiornamenti",
    isActive: true,
    createdAt: "2025-12-02T10:09:00.000Z",
  },

  //  mixed: string + number + date + time + datetime (stress test)
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f06",
    name: "Stress test input types",
    content:
      "Riepilogo:\r\n- Cliente: {{customerName}}\r\n- Pratica: {{caseNumber}}\r\n- Data: {{caseDate}}\r\n- Ora: {{caseTime}}\r\n- Appuntamento: {{caseDateTime}}",
    templateSid: "tpl_stress_test_input_types",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [
      { key: "customerName", type: "string" },
      { key: "caseNumber", type: "number" },
      { key: "caseDate", type: "date" },
      { key: "caseTime", type: "time" },
      { key: "caseDateTime", type: "datetime" },
    ],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c05",
    categoryName: "Test",
    isActive: true,
    createdAt: "2025-12-02T10:10:00.000Z",
  },

  // disattivo non si vede
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f07",
    name: "Template disattivato (test)",
    content: "QUESTO TEMPLATE NON DOVREBBE VEDERSI perché isActive=false.",
    templateSid: "tpl_test_disattivato",
    teams: [{ id: "10000000-0000-0000-0000-000000000004", name: "Customer" }],
    variables: [{ key: "x", type: "string" }],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c99",
    categoryName: "Test",
    isActive: false,
    createdAt: "2025-12-02T10:11:00.000Z",
  },

  //  supervisor + datetime
  {
    id: "2b0f1c2a-7d6c-4b0e-9a2a-1d9b5a2f7f08",
    name: "Escalation a supervisore",
    content:
      "Ti ringrazio. Inoltro la richiesta a un supervisore.\r\nTempo stimato: {{etaAt}}",
    templateSid: "tpl_escalation_supervisore",
    teams: [{ id: "10000000-0000-0000-0000-000000000002", name: "Supervisor" }],
    variables: [{ key: "etaAt", type: "datetime" }],
    categoryId: "c1b6f1eb-3a2a-4b1a-9d56-0a3d4a5b6c06",
    categoryName: "Escalation",
    isActive: true,
    createdAt: "2025-12-02T10:12:00.000Z",
  },
];
